import React from "react";
import {Link} from "@reach/router";
import classNames from "classnames";

const CardTitle = ({ children }) => (
  <h3 className="card-title">{children}</h3>
);

const CardText = ({ children }) => (
  <p className="card-text">{children}</p>
);

const CardLink = ({ children, to, dark, block }) => {
  const className = classNames({
    "btn": true,
    "btn-card": true,
    "btn-dark": dark === true,
    "btn-block": block === true
  });

  return <Link to={to} className={className}>
    {children}
  </Link>;
};

const CardImage = (props) => {
  const styles = {width:'-webkit-fill-available !important'}
  return (
    <div className="card-image">
      <img {...props} style={styles}/>
    </div>
  );
};

const Card = ({bg, children, dark}) => {
  const styles = {};
  const cardClasses = classNames({
    card: true,
    'bg-blue': dark === true
  });

  return (
    <div className={cardClasses}>
      <div className="card-body">
        {children}
      </div>
    </div>
  );
};

export { Card, CardTitle, CardText, CardLink, CardImage };
